import { useEffect, useState } from "react";
import Flicking from "@egjs/react-flicking";
import { Perspective } from "@egjs/flicking-plugins";
import ItemView from "./itemview";
import BasicDocView from "../basicdocView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { set } from "date-fns";
import "@egjs/flicking/dist/flicking.css";
import "@egjs/flicking/dist/flicking-inline.css";
import arrowright from '../../../assets/arraowrightv2.png'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
const FlickingCor = ({ cards, default_template, selectedTemplate, setSelectedTemlate, mydata }) => {
  const plugins = [new Perspective({ rotate: 1, scale: 1, perspective: 1000 })];
  const [flickingRef, setFlickingRef] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const DOTS_PER_PAGE = 5;
  const totalPages = Math.ceil(cards.length / DOTS_PER_PAGE);
  const [sortedCards, setSortedCards] = useState([]); // Store sorted cards in state

  useEffect(() => {
    // Sorting should happen only once when the component mounts
    if(activeIndex!=0){
      return
    }
    const sorted = [...cards].sort((a, b) => {
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      return keyA === default_template ? -1 : keyB === default_template ? 1 : 0;
    });

    setSortedCards(sorted);

  }, [cards,default_template]);
  // Determine the current group of dots to show
  const getDotPage = (index) => Math.floor(index / DOTS_PER_PAGE);
  const currentPage = getDotPage(activeIndex);
  const visibleDots = cards.slice(
    currentPage * DOTS_PER_PAGE,
    (currentPage + 1) * DOTS_PER_PAGE
  );
  const handlePrev = () => {
    if (flickingRef) {
      flickingRef.prev().catch(() => {
        // Optional: Handle edge cases if the carousel can't move
      });
    }
  };

  const handleNext = () => {
    if (flickingRef) {
      flickingRef.next().catch(() => {
        // Optional: Handle edge cases if the carousel can't move
      });
    }
  };

  const handleMove = (e) => {
    setActiveIndex(e.panel.index);

setSelectedTemlate( Object.keys(sortedCards[e.panel.index])[0])
  };
  
// console.log(sortedCards,'sorted')
  return (
    <div className="w-full relative h-full">
      {/* Flicking carousel container */}
      <button
  className="absolute top-[50%] w-8 h-8 flex items-center justify-center left-[93%] sm:left-[95%] z-50 p-2 text-[#333333] rounded-full border border-[#E4E4E7] bg-white/80 shadow-lg backdrop-blur-sm"
  onClick={handleNext}
>
 <ChevronRightIcon/>
</button>
<button  className="absolute top-[50%] w-8 h-8 flex items-center justify-center right-[93%] sm:right-[95%] z-50 p-2 text-[#333333] rounded-full border border-[#E4E4E7] bg-white/80 shadow-lg backdrop-blur-sm"
 onClick={handlePrev}>
<ChevronLeftIcon/>
        </button>
      <Flicking
        circular={true}
        plugins={plugins}
        horizontal={true}
        align="center"
        // gap={20}
        // gap={10}
        className="flicking-container"
        ref={setFlickingRef}
        onChanged={handleMove}
      >
        {sortedCards.map((card, index) => {
          // console.log(card,'card')
          let documentK;
          let documentData;
          const documentKey = Object.keys(card)[0];
          if (card.populatedtemp && typeof card.populatedtemp === 'object' && Object.keys(card.populatedtemp).length > 0) {
            documentK = 'populatedtemp';
            documentData = card.populatedtemp;
          } else {
            documentK= Object.keys(card)[0];
            documentData = card[documentK];
          }

          return (
            <div
              key={index}
              className={`flicking-slide w-full flex justify-center items-center flex-col sm:w-[500px] h-full p-4 bg-white shadow-md rounded-lg border-2 
                ${selectedTemplate === documentKey ?"border-[#A2C6FD]":'border-[#E5E7EB]'} `}
            >
              {documentKey === default_template ? (< div className="flex justify-start ">
              
               <div className="text-xs  text-start  mb-2  rounded-full border border-[#E4E4E7]  bg-white/80 backdrop-blur-sm px-3 py-1 ">
          Default
        </div>
              </div>
         
        
              ) : (
                <></>
        //         < div className="flex justify-start ">
              
        //        {selectedTemplate === documentKey ? <div className="text-xs  text-start text-white mb-2  rounded-full border border-[#E4E4E7]  bg-[#3B82F6] backdrop-blur-sm px-3 py-1 ">
        // Selected
        //  </div>:<></>}
        //        </div>
              )}

              {mydata.usertype === "BASIC" ? (
                <BasicDocView
                  setSelectedTemlate={setSelectedTemlate}
                  documentKey={documentKey}
                  selectedTemplate={selectedTemplate}
                  data={documentData}
                  defaulttemp={documentKey === default_template}
                />
              ) : (
                <ItemView
                  setSelectedTemlate={setSelectedTemlate}
                  documentKey={documentKey}
                  selectedTemplate={selectedTemplate}
                  data={documentData}
                  defaulttemp={documentKey === default_template}
                />
              )}
                  <div className="text-md text-start mt-4 font-semibold ">
                  {documentKey === "HnP"
                    ? "History & Physical"
                    : documentKey === "soap_note"
                    ? "SOAP Note"
                    : documentKey}
                </div>
            </div>
          );
        })}
        
      </Flicking>
      
      {/* Navigation icons and dots */}
      <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-4 mt-8 z-10">
       

        {/* Dots */}
        <div className="flex gap-2">
          {visibleDots.map((_, index) => {
            const dotIndex = currentPage * DOTS_PER_PAGE + index;
            return (
              <div
                key={dotIndex}
                className={`w-6 h-2 rounded-full ${
                  dotIndex === activeIndex ? "bg-[#2563EB]" : "bg-gray-300"
                }`}
              ></div>
            );
          })}
        </div>

       
      </div>

      <style jsx>{`
        .flicking-container {
          position: relative;
          overflow: hidden;
    
        }
        .flicking-slide {
          position: relative;
          transform-style: preserve-3d;
        }
      `}</style>
    </div>
  );
};

export default FlickingCor;
